var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import Axios from 'axios';
import Qs from 'qs';
import dayjs from 'dayjs';
/** @use Axios 请求config处理 */
var axiosConfig = function (config) {
    var tempConfig = config;
    if (tempConfig.method === 'get') {
        tempConfig.params = __assign(__assign({}, tempConfig.params), { _: dayjs().valueOf() });
    }
    tempConfig.headers = __assign({}, tempConfig.headers);
    return tempConfig;
};
function request(params) {
    var kfInstance = Axios.create({
        headers: {
        // 'x-requested-with': 'XMLHttpRequest',
        // 'x-prevent-preflight': true
        },
        baseURL: '/',
        withCredentials: true
    });
    kfInstance.interceptors.request.use(function (config) {
        var tempConfig = axiosConfig(config);
        return tempConfig;
    }, function (err) {
        return Promise.reject(err.toString());
    });
    kfInstance.interceptors.response.use(function (res) {
        var data = res.data;
        if (!res.data) {
            alert('数据返回失败');
            return Promise.reject(res);
        }
        // 将后端返回的 {code, message, message} 转换为 {c, d, e}
        var transformedData = {
            c: data.code,
            d: data.result,
            e: data.message
        };
        // 更新响应数据
        res.data = transformedData;
        switch (transformedData.c) {
            case 0:
                return Promise.resolve(res);
            case 200:
                return Promise.resolve(res);
            case 201:
                return Promise.resolve(res);
            default:
                return Promise.reject(res);
        }
    }, function (err) {
        var _a, _b;
        if (err.message) {
            if (err.message === 'Network Error') {
                // eslint-disable-next-line prefer-promise-reject-errors
                return Promise.reject('当前网络不给力，请检查您的网络');
            }
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject("\u8BF7\u6C42\u9519\u8BEF ".concat((_a = err.response) === null || _a === void 0 ? void 0 : _a.status, "\uFF1A").concat((_b = err.response) === null || _b === void 0 ? void 0 : _b.statusText));
        }
        return Promise.reject(err.toString());
    });
    return kfInstance(params);
}
export var youpaiGet = function (url, params, options) {
    return request(__assign({ method: 'GET', url: url, params: params }, options));
};
export var youpaiPost = function (url, data, options) {
    return request(__assign({ method: 'POST', url: url, data: Qs.stringify(data) }, options));
};
